export type ButtonAppearanceProps = {
    mobileSpacing?: 'standard' | 'compact' | 'tight';
    fixedMobileHeight?: boolean;
    comfortableLabel?: boolean;
    compactDesktop?: boolean;
};

export const MOBILE_BUTTON_PADDING = {
    standard: '8px 24px',
    compact: '8px 16px',
    tight: '8px',
};
